import { useMemo } from "react";

import {
  STATUS_EDIT_ROLES,
  NAME_EDIT_ROLES,
  PRIORITIES_EDIT_ROLES,
  DESCRIPTION_EDIT_ROLES,
  AUTHOR_EDIT_ROLES,
  EXECUTOR_EDIT_ROLES,
  EXECUTOR_SET_ME_ROLES,
  START_DATE_EDIT_ROLES,
  DUE_DATE_EDIT_ROLES,
  PARENT_TASK_EDIT_ROLES,
  COEXECUTOR_EDIT_ROLES,
  ACCEPTOR_EDIT_ROLES,
  ACCEPTOR_SET_ME_ROLES,
  TASK_TYPES_EDIT_ROLES,
  TASK_SPRINT_EDIT_ROLES,
  isTaskStatusFinal,
} from "@/constants/tasks";

// Хук для определения прав пользователя на редактирование различных полей задачи
export const useTaskPermissions = (
  data,
  {
    user,
    executorsOptions = [],
    acceptorsOptions = [],
    isExecutor = false,
    isAcceptor = false,
  } = {}
) => {
  return useMemo(() => {
    const hasRoles = Boolean(data?.uuid && Array.isArray(data?.roles));
    const isFinal = isTaskStatusFinal(data?.status);
    const can = (allowedRoles) =>
      !isFinal &&
      (!hasRoles || data.roles.some((role) => allowedRoles.includes(role)));

    const perms = {
      isUserCanEditStatus: can(STATUS_EDIT_ROLES),
      isUserCanEditName: can(NAME_EDIT_ROLES),
      isUserCanEditPriority: can(PRIORITIES_EDIT_ROLES),
      isUserCanEditDescription: can(DESCRIPTION_EDIT_ROLES),
      isUserCanEditAuthor: can(AUTHOR_EDIT_ROLES),
      isUserCanEditExecutor: can(EXECUTOR_EDIT_ROLES),
      isUserSetMeExecutor: can(EXECUTOR_SET_ME_ROLES),
      isUserCanEditAcceptor: can(ACCEPTOR_EDIT_ROLES),
      isUserSetMeAcceptor: can(ACCEPTOR_SET_ME_ROLES),
      isUserCanEditStartDate: can(START_DATE_EDIT_ROLES),
      isUserCanEditDueDate: can(DUE_DATE_EDIT_ROLES),
      isUserCanEditParentTask: can(PARENT_TASK_EDIT_ROLES),
      isUserCanEditCoexecutors: can(COEXECUTOR_EDIT_ROLES),
      isUserCanEditTaskType: can(TASK_TYPES_EDIT_ROLES),
      isUserCanEditSprint: can(TASK_SPRINT_EDIT_ROLES),
    };

    const showSetMeExecutor = (() => {
      const access =
        perms.isUserSetMeExecutor &&
        !isExecutor &&
        executorsOptions.map((u) => u.uuid).includes(user?.employee_uuid);
      if (!access) return false;
      if (perms.isUserSetMeExecutor && !perms.isUserCanEditExecutor) {
        return !data?.responsible_executor_uuid;
      }
      return access;
    })();

    const showSetMeAcceptor = (() => {
      const access =
        perms.isUserSetMeAcceptor &&
        !isAcceptor &&
        acceptorsOptions.map((u) => u.uuid).includes(user?.employee_uuid);
      if (!access) return false;
      if (perms.isUserSetMeAcceptor && !perms.isUserCanEditAcceptor) {
        return !data?.assignee_acceptor_uuid;
      }
      return access;
    })();

    return { ...perms, showSetMeExecutor, showSetMeAcceptor };
  }, [data, user, executorsOptions, acceptorsOptions, isExecutor, isAcceptor]);
};

export default useTaskPermissions;
